<template>
  <div class="inline-keyboard" :class="type">
    <ul v-if="layout && layout.length > 0">
      <li v-for="(button, key) in layout" v-html="renderButton(button)" :class="renderClass(button)" :key="key"></li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'inline-keyboard',
  props: {
    layout: {
      type: Array
    },
    type: {
      type: String,
      required: false,
      default: ''
    }
  },
  watch: {
    layout () {
      this.destroyEvents()

      let vm = this
      this.$nextTick(() => {
        vm.initEventListeners()
      })
    }
  },
  methods: {
    renderButton (button) {
      if (!button) {
        return ''
      }

      let label = ''
      let symbol = ''
      let type = ''

      if (typeof button[0] === 'string') {
        label = button[0]
        symbol = button[0]
      } else {
        label = button[0].label
        symbol = button[0].label
        if ('type' in button[0]) {
          type = button[0].type
        }

        if ('width' in button[0]) {
          type += ' ' + button[0].width
        }
      }

      if (label === 'break') {
        return '<br>'
      }

      if (label === 'empty') {
        return '<span class="empty-cell"></span>'
      }

      if (label === 'space') {
        label = '<span class="space"></span>'
      }

      if (label === 'return') {
        label = '<span class="indicator return">&#9664;</span>'
      }

      if (label === 'del') {
        label = '&#9664;'
      }

      return `<button data-long-press-delay="500" data-char="${symbol}" class="${type}">${label}</button>`
    },
    renderClass (button) {
      let label = ''
      let type = ''
      if (typeof button[0] === 'string') {
        label = button[0]
      } else {
        label = button[0].label
        if ('type' in button[0]) {
          type = button[0].type
        }

        if ('width' in button[0]) {
          type += ' ' + button[0].width
        }
      }

      return label + ' ' + type
    },
    onButtonClick (e) {
      e.preventDefault()
      let element = e.toElement || e.target
      if (element.tagName !== 'BUTTON') {
        while ((element = element.parentElement) && element.tagName !== 'BUTTON') {
        }
      }

      this.$emit('press', element.getAttribute('data-char'))
    },
    initEventListeners () {
      let buttons = document.querySelectorAll('.inline-keyboard button')
      if (buttons) {
        let vm = this
        buttons.forEach((el) => {
          el.addEventListener('click', vm.onButtonClick, false)
          el.addEventListener('long-press', vm.onButtonClick, false)
        })
      }
    },
    destroyEvents () {
      let buttons = document.querySelectorAll('.inline-keyboard button')
      if (buttons) {
        let vm = this
        buttons.forEach((el) => {
          el.removeEventListener('click', vm.onButtonClick)
          el.removeEventListener('long-press', vm.onButtonClick)
        })
      }
    }
  },
  mounted () {
    this.initEventListeners()
  },
  beforeDestroy () {
    this.destroyEvents()
  }
}
</script>

<style lang="scss">
  .inline-keyboard {
    height: 100%;
    display: flex;
    justify-content: center;
    font-size: 40px;
    ul {
      display: grid;
      width: 100%;
      grid-template-columns: 30% 30% 30%;
      grid-gap: 5%;
      li {
        width: 100%;
        button {
          border-radius: 5px;
          width: 100%;
          height: 100%;
          background-color: #E7E6E7;
          color: black;
          padding: 0.5em 0em;
          margin: 0;
          border: 0;
          cursor: pointer;
          &:active {
            background-color: #CCCCCC;
          }
        }
        &.break {
          display:none;
          width: 0%;
          height: 0%;
        }
        &.wide {
          grid-column: 1 / 3;
        }
        &.del {
          font-size: 38px;
        }
      }
    }
  }
</style>
